import { getCustomizedDate } from "../constants/index";
import moment from "moment";
import {
  setClearGraphData,
  setGlobalFilter,
  setPaneDuration,
} from "./dashboard/Tab1";
import { setOptionHighChart } from "./HighChart";
import { setDurationInScreen } from "./commandCenter/screens/screen";

export const setDateValue = (dateValue, value, type) => {
  let updateValue = { ...dateValue };
  updateValue[type].data = value;
  return { type: "SET_DATE_VALUE", payload: updateValue };
};
export const setTimeValue = (timeValue, value, type) => {
  let updateValue = { ...timeValue };
  updateValue[type].data = value;

  return { type: "SET_TIME_VALUE", payload: updateValue };
};
export const setdateRange = (value) => {
  return { type: "SET_DATE_RANGE", payload: value };
};

export const setRelativeCount = (value) => {
  return { type: "SET_RELATIVE_COUNT", payload: value };
};
export const setDateTimeFlag = (value) => {
  return { type: "SET_DATETIME_FLAG", payload: value };
};

const getDateAndTime = (durationObject) => {
  let dateObj = {
    date: [
      moment(
        durationObject?.from ? durationObject?.from : durationObject?.[0]
      ).format("DD MMM  YYYY"),
      moment(
        durationObject?.to ? durationObject?.to : durationObject?.[1]
      ).format("DD MMM  YYYY"),
    ],
    time: {
      startTime: moment(
        durationObject?.from ? durationObject?.from : durationObject?.[0]
      ).format("HH:mm"),
      endTime: moment(
        durationObject?.to ? durationObject?.to : durationObject?.[1]
      ).format("HH:mm"),
    },
  };

  return dateObj;
};

export const setSplitDateValue = (durationObject) => {
  let updatedateValue = { ...durationObject?.dateValue };
  let updateTimeValue = { ...durationObject?.timeValue };

  if (updatedateValue) {
    let date1 = [
      moment(durationObject?.value?.defaultDate1[0]).format("DD MMM YYYY"),
      moment(durationObject?.value?.defaultDate1[1]).format("DD MMM YYYY"),
    ];

    let time1 = {
      startTime: moment(durationObject?.value?.defaultDate1[0]).format("HH:mm"),
      endTime: moment(durationObject?.value?.defaultDate1[1]).format("HH:mm"),
    };

    let date2 = [
      moment(durationObject?.value?.defaultDate2[0]).format("DD MMM YYYY"),
      moment(durationObject?.value?.defaultDate2[1]).format("DD MMM YYYY"),
    ];
    let time2 = {
      startTime: moment(durationObject?.value?.defaultDate2[0]).format("HH:mm"),
      endTime: moment(durationObject?.value?.defaultDate2[1]).format("HH:mm"),
    };
    let date3 = [
      moment(durationObject?.value?.defaultDate3[0]).format("DD MMM YYYY"),
      moment(durationObject?.value?.defaultDate3[1]).format("DD MMM YYYY"),
    ];
    let time3 = {
      startTime: moment(durationObject?.value?.defaultDate3[0]).format("HH:mm"),
      endTime: moment(durationObject?.value?.defaultDate3[1]).format("HH:mm"),
    };

    let finalDateObj, finalTimeObj;
    finalDateObj = {
      one: date1,
      two: date2,
      three: date3,
    };

    finalTimeObj = {
      one: time1,
      two: time2,
      three: time3,
    };

    updatedateValue[durationObject?.type].data = finalDateObj;
    updateTimeValue[durationObject?.type].data = finalTimeObj;
  }

  return (dispatch) => {
    dispatch({ type: "SET_DATE_VALUE", payload: updatedateValue });
    dispatch({ type: "SET_TIME_VALUE", payload: updateTimeValue });
  };
};

export const setGlobalDateValue = (durationObject) => {
  let updatedateValue = { ...durationObject?.dateValue };
  let updateTimeValue = { ...durationObject?.timeValue };
  let updateRelativeValue = null;

  let dateObj;
  if (durationObject?.value) {
    dateObj = getDateAndTime(durationObject?.value);
    if (durationObject?.value?.relative) {
      dateObj.date.relative = durationObject?.value?.relative;
      updateRelativeValue = durationObject?.value?.relative;
      dateObj.date.save_as_relative = durationObject?.value?.save_as_relative;
    }
  } else if (!durationObject?.value && updatedateValue) {
    dateObj = getCustomizedDate(6, "Days");
  }
  if (updatedateValue) {
    updatedateValue[durationObject?.type].data = dateObj?.date;
  }
  if (updateTimeValue) {
    updateTimeValue[durationObject?.type].data = dateObj?.time;
  }

  return (dispatch) => {
    dispatch({ type: "SET_DATE_VALUE", payload: updatedateValue });
    dispatch({ type: "SET_TIME_VALUE", payload: updateTimeValue });
    dispatch({ type: "SET_RELATIVE_COUNT", payload: updateRelativeValue });
  };
};

export const setSectionDateValue = (durationObject) => {
  let updatedateValue = { ...durationObject?.dateValue };
  let updateTimeValue = { ...durationObject?.timeValue };
  let updateRelativeValue = null;

  if (updatedateValue) {
    let dateObj;

    if (durationObject?.value) {
      dateObj = getDateAndTime(durationObject?.value);
      if (durationObject?.value?.relative) {
        dateObj.date.relative = durationObject?.value?.relative;
        updateRelativeValue = durationObject?.value?.relative;
        dateObj.date.save_as_relative = durationObject?.value?.save_as_relative;
      }
    }
    // else if (
    //   !durationObject?.value &&
    //   durationObject?.global_duration?.from
    // ) {
    //   dateObj = getDateAndTime(durationObject?.global_duration);
    //   if (durationObject?.global_duration?.relative) {
    //     dateObj.date.relative = durationObject?.value?.relative;
    //     updateRelativeValue = durationObject?.global_duration?.relative;
    //   }
    // } else {
    //   dateObj = getCustomizedDate(6, "Days");
    // }
    updatedateValue[durationObject?.type].data = dateObj?.date
      ? dateObj?.date
      : null;
    updateTimeValue[durationObject?.type].data = dateObj?.time
      ? dateObj?.time
      : null;
  }

  return (dispatch) => {
    dispatch({ type: "SET_DATE_VALUE", payload: updatedateValue });
    dispatch({ type: "SET_TIME_VALUE", payload: updateTimeValue });
    dispatch({ type: "SET_RELATIVE_COUNT", payload: updateRelativeValue });
  };
};

export const setWidgetDateValue = (durationObject) => {
  let updatedateValue = { ...durationObject?.dateValue };
  let updateTimeValue = { ...durationObject?.timeValue };
  let updateRelativeValue = null;
  if (updatedateValue) {
    let dateObj;

    if (durationObject?.value) {
      dateObj = getDateAndTime(durationObject?.value);
      if (durationObject?.value?.relative) {
        dateObj.date.relative = durationObject?.value?.relative;
        updateRelativeValue = durationObject?.value?.relative;
        dateObj.date.save_as_relative = durationObject?.value?.save_as_relative;
      }
    }
    // else if (
    //   !durationObject?.value &&
    //   durationObject?.global_duration?.from
    // ) {
    //   dateObj = getDateAndTime(durationObject?.global_duration);
    //   if (durationObject?.global_duration?.relative) {
    //     dateObj.date.relative = durationObject?.value?.relative;
    //     updateRelativeValue = durationObject?.global_duration?.relative;
    //   }
    // } else {
    //   dateObj = getCustomizedDate(6, "Days");
    // }

    updatedateValue[durationObject?.type].data = dateObj?.date
      ? dateObj?.date
      : null;
    updateTimeValue[durationObject?.type].data = dateObj?.time
      ? dateObj?.time
      : null;
  }

  return (dispatch) => {
    dispatch({ type: "SET_DATE_VALUE", payload: updatedateValue });
    dispatch({ type: "SET_TIME_VALUE", payload: updateTimeValue });
    dispatch({ type: "SET_RELATIVE_COUNT", payload: updateRelativeValue });
  };
};
export const setGraphPageDateValue = (durationObject) => {
  let updatedateValue = { ...durationObject?.dateValue };
  let updateTimeValue = { ...durationObject?.timeValue };
  let updateRelativeValue = null;
  if (updatedateValue) {
    let dateObj;
    if (durationObject?.value) {
      dateObj = getDateAndTime(durationObject?.value);
      if (durationObject?.value?.relative) {
        dateObj.date.relative = durationObject?.value?.relative;
        updateRelativeValue = durationObject?.value?.relative;
      }
    } else {
      dateObj = getCustomizedDate(6, "Days");
    }

    updatedateValue[durationObject?.type].data = dateObj?.date;
    updateTimeValue[durationObject?.type].data = dateObj?.time;
  }

  return (dispatch) => {
    dispatch({ type: "SET_DATE_VALUE", payload: updatedateValue });
    dispatch({ type: "SET_TIME_VALUE", payload: updateTimeValue });
    dispatch({ type: "SET_RELATIVE_COUNT", payload: updateRelativeValue });
  };
};
export const setOrmDateValue = (durationObject) => {
  let updatedateValue = { ...durationObject?.dateValue };
  let updateTimeValue = { ...durationObject?.timeValue };
  let updateRelativeValue = null;
  if (updatedateValue) {
    let dateObj;
    if (durationObject?.value) {
      dateObj = getDateAndTime(durationObject?.value);
      if (durationObject?.value?.relative) {
        dateObj.date.relative = durationObject?.value?.relative;
        updateRelativeValue = durationObject?.value?.relative;
        dateObj.date.save_as_relative = durationObject?.value?.save_as_relative;
      }
    } else {
      dateObj = getCustomizedDate(6, "Days");
    }

    updatedateValue[durationObject?.type].data = dateObj?.date;
    updateTimeValue[durationObject?.type].data = dateObj?.time;
  }

  return (dispatch) => {
    dispatch({ type: "SET_DATE_VALUE", payload: updatedateValue });
    dispatch({ type: "SET_TIME_VALUE", payload: updateTimeValue });
    dispatch({ type: "SET_RELATIVE_COUNT", payload: updateRelativeValue });
  };
};
export const setCommandCenterDateValue = (durationObject) => {
  let updatedateValue = { ...durationObject?.dateValue };
  let updateTimeValue = { ...durationObject?.timeValue };
  let updateRelativeValue = null;

  let dateObj;
  if (durationObject?.value) {
    dateObj = getDateAndTime(durationObject?.value);
    if (durationObject?.value?.relative) {
      dateObj.date.relative = durationObject?.value?.relative;
      updateRelativeValue = durationObject?.value?.relative;
    }
  } else if (!durationObject?.value && updatedateValue) {
    dateObj = getCustomizedDate(0, "Days");
  }
  if (updatedateValue) {
    updatedateValue[durationObject?.type].data = dateObj?.date;
  }
  if (updateTimeValue) {
    updateTimeValue[durationObject?.type].data = dateObj?.time;
  }

  return (dispatch) => {
    dispatch({ type: "SET_DATE_VALUE", payload: updatedateValue });
    dispatch({ type: "SET_TIME_VALUE", payload: updateTimeValue });
    dispatch({ type: "SET_RELATIVE_COUNT", payload: updateRelativeValue });
  };
};

export const setCrisisChecked = (value) => {
  return { type: "SET_CRISIS_CHECKED", payload: value };
};
export const setCrisisDates = (value) => {
  return { type: "SET_CRISIS_DATE", payload: value };
};

export const updateWidgetDuration = (paneObj) => {
  const updatePanes = [...paneObj?.panes];
  let section_id = updatePanes?.[paneObj?.index]?.sections
    ? updatePanes?.[paneObj?.index]?.sections?.[paneObj?.section_index]
        ?.section_id
    : updatePanes?.[paneObj?.index]?.section?.[0]?.section_id;
  let widget_id = updatePanes?.[paneObj?.index]?.sections
    ? updatePanes?.[paneObj?.index]?.sections?.[paneObj?.section_index]
        ?.widgets?.[paneObj?.widget_index]?.widget_id
    : updatePanes?.[paneObj?.index]?.section?.[0]?.widgets?.[
        paneObj?.widget_index
      ]?.widget_index;
  let dateFilters = paneObj?.duration?.from
    ? [
        {
          attribute: "CreatedDate",
          type: "datetime",
          columns: {
            from: paneObj?.duration?.from,
            to: paneObj?.duration?.to,
            save_as_relative: paneObj?.duration?.save_as_relative,
            relative: paneObj?.duration?.relative,
          },
        },
      ]
    : null;

  let paneObject = {
    index: paneObj?.index,
    brands: paneObj?.brands,
    panes: paneObj?.panes,
    activeKey: paneObj?.activeKey,
    section_id: section_id,
    widget_index: paneObj?.widget_index,
    widget_id: widget_id,
    dateFilters: dateFilters,
    type: "dashboard_widget",
  };
  return (dispatch) => {
    dispatch(setDashboardDateFilterObj(paneObject));
  };
};

export const updateSectionDuration = (paneObj) => {
  const updatePanes = [...paneObj?.panes];

  let section_id =
    updatePanes[paneObj?.index]?.sections[paneObj?.section_index].section_id;
  let dateFilters = paneObj?.duration?.from
    ? [
        {
          attribute: "CreatedDate",
          type: "datetime",
          columns: {
            from: paneObj?.duration?.from,
            to: paneObj?.duration?.to,
            save_as_relative: paneObj?.duration?.save_as_relative,
            relative: paneObj?.duration?.relative,
          },
        },
      ]
    : null;

  let paneObject = {
    index: paneObj?.index,
    brands: paneObj?.brands,
    panes: paneObj?.panes,
    activeKey: paneObj?.activeKey,
    section_id: section_id,
    dateFilters: dateFilters,
    type: "dashboard_section",
  };
  return (dispatch) => {
    dispatch(setDashboardDateFilterObj(paneObject));
  };
};

export const updateDashboardDuration = (paneObj) => {
  return (dispatch) => {
    dispatch(setPaneDuration(paneObj, "global_dashboard"));
    dispatch(
      setClearGraphData(paneObj?.index, paneObj?.panes, "global_duration")
    );
    dispatch(setGlobalFilter(null, paneObj?.index, paneObj?.panes, paneObj));
    // dispatch(setOptionHighChart(null));
  };
};

export const setDashboardDateFilterObj = (paneObj) => {
  return (dispatch) => {
    dispatch({ type: "DASHBOARD_DATE_FFILTER_OBJ", payload: paneObj });
  };
};

export const setSingleDate = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_SINGLE_DATE", payload: value });
  };
};
export const setPrevieDate = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_PREVIEW_DATE", payload: value });
  };
};
